import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwitchLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"switch_left"}/>
}
